import { Link } from 'react-router-dom';
import logoImage from '../../../assets/logo_256.png';

function LogoComponent() {
    return (
        <Link to="/" className="logo-component">
            <img src={logoImage} alt="Study Corner logo" className="logo-image"/>
        </Link>
    );
}

export default LogoComponent;